<template>
  <AppView :title="app" :footerShow="false" :orderPage="true">
    <div class="flex w-full h-full overflow-hidden">
      <div class="bg-desert-storm h-full flex-none overflow-y-scroll scrollbar-hide">
        <!-- 商品類別區 -->
        <Navigation class="w-[90px] h-full" />
      </div>

      <!-- 商品列表 -->
      <div class="h-full flex-grow overflow-hidden">
        <ProductList />
      </div>
    </div>
  </AppView>
</template>

<script>
import Navigation from "@/components/product/Navigation.vue";
import ProductList from "@/components/product/List";

export default {
  components: { Navigation, ProductList },
  auth: false,

  head() {
    const info = this.$store.getters["app/info"];
    const url = `${process.env.APP_URL}/order`;
    return {
      title: process.env.APP_NAME,
      meta: [
        {
          hid: "canonical",
          rel: "canonical",
          href: url,
        },
        {
          hid: "keywords",
          name: "keywords",
          content: info.keywords,
        },
        {
          hid: "description",
          name: "description",
          content: info.description,
        },
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: info.name,
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          property: "og:site_name",
          content: info.name,
        },
        {
          hid: "og:url",
          name: "og:url",
          property: "og:url",
          content: url,
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: info.description,
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: `${process.env.APP_URL}/static/icon.png`,
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: url,
        },
      ],
    };
  },
  data() {
    return {
      app: process.env.APP_NAME,
    };
  },
  methods: {
    scrollTo(type) {
      this.$nextTick(() => {
        // delay 1 tick to wait for DOM update
        setTimeout(() => {
          const ele = document.querySelector(`[aria-colindex="${type}"]`);
          ele.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }, 100);
      });
    },
  },
  
  mounted() {
    const type = this.$route.query.type;
    if (!type) return;
    this.scrollTo(type);
  },
};
</script>

<style scoped></style>
